/**
 * Shared date formatter for consistent display across the app.
 * @param {string|number|Date|null|undefined} dateStr - ISO date string, timestamp, or Date
 * @returns {string} Formatted date (e.g. "10 Feb 2026") or "–" if invalid/missing
 */
export function formatDate(dateStr) {
  if (dateStr == null || dateStr === '') return '–';
  const date = typeof dateStr === 'object' && dateStr instanceof Date
    ? dateStr
    : new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '–';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
